import { TeamStats } from '../types';

export const getFilteredMatches = (
  matches: any[],
  selectedStat: string | null,
  selectedLocation: 'overall' | 'home' | 'away' | null,
  teamName: string
) => {
  if (!selectedStat || !selectedLocation) return [];

  return matches.filter(match => {
    const isHomeMatch = match.HomeTeam === teamName;
    const isAwayMatch = match.AwayTeam === teamName;

    // Filter by location first
    if (selectedLocation === 'home' && !isHomeMatch) return false;
    if (selectedLocation === 'away' && !isAwayMatch) return false;
    if (selectedLocation === 'overall' && !isHomeMatch && !isAwayMatch) return false;

    switch (selectedStat) {
      case 'wins':
        return (isHomeMatch && match.FTR === 'H') || (isAwayMatch && match.FTR === 'A');
      case 'draws':
        return match.FTR === 'D';
      case 'losses':
        return (isHomeMatch && match.FTR === 'A') || (isAwayMatch && match.FTR === 'H');
      case 'halfTimeWins':
        return (isHomeMatch && match.HTR === 'H') || (isAwayMatch && match.HTR === 'A');
      case 'halfTimeDraws':
        return match.HTR === 'D';
      case 'halfTimeLosses':
        return (isHomeMatch && match.HTR === 'A') || (isAwayMatch && match.HTR === 'H');
      case 'cleanSheets':
        if (isHomeMatch) {
          return match.FTAG === '0';
        }
        if (isAwayMatch) {
          return match.FTHG === '0';
        }
        return false;
      case 'btts':
        return parseInt(match.FTHG) > 0 && parseInt(match.FTAG) > 0;
      case 'htBtts':
        return parseInt(match.HTHG) > 0 && parseInt(match.HTAG) > 0;
      default:
        return false;
    }
  });
};